<template>
    <section class="sub-visual-wrap"
        :style="`background-image: url(${require(`@/assets/subvisual_background/${this.$route.meta.subVisualSrc}`)});`">
        <div class="sub-visual-inner">
            <div class="sub-visual-content">
                <h1 data-aos="fade-right">
                    {{ this.$route.meta.depth >= 1 ? this.$route.meta.parent[$t('common.name')] :
                        this.$route.meta[$t('common.name')] }}
                </h1>
                <div class="sitemap-wrap">
                    <a href="/" class="ic">
                        <img src="@/assets/ic_home.png" alt="" />
                    </a>

                    <template v-for="(item, index) in sitemap" :key="index">
                        <i class="ic">
                            <img src="@/assets/ic_arrow_right-w.png" alt="Arrow" />
                        </i>
                        <span>{{ item[$t('common.title')] }}</span>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        sitemap: {},
        src: {},
    },
};
</script>
<style lang="scss" scoped>
.sub-visual-wrap {
    width: 100%;
    height: 490px;
    background-color: #333;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-position: center;

    .sub-visual-inner {
        position: relative;
        width: 100%;
        max-width: 1540px;

        .sub-visual-content {
            width: 100%;
            left: 0;
            position: absolute;
            bottom: 80px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
        }

        h1 {
            display: inline-block;
            font-family: 'Pretendard', sans-serif;
            font-size: 60px;
            color: #fff;
            font-weight: 700;
            letter-spacing: -0.025em;
        }

        .sitemap-wrap {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;

            span {
                font-family: 'Pretendard', sans-serif;
                text-decoration: none;
                font-weight: 500;
                color: #fff;
                font-size: 16px;
                line-height: 1;
                letter-spacing: -0.025em;
            }
        }

        .ic {
            width: 24px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;

            @media screen and (max-width: 768px) {
                width: 14px;
                height: 14px;
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    .sub-visual-wrap {
        height: 400px;

        .sub-visual-inner {
            max-width: 90%;

            .sub-visual-content {
                bottom: 35px;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .sub-visual-wrap {
        height: 100%;
        min-height: 300px;
        aspect-ratio: 1/0.6;

        .sub-visual-inner {
            .sub-visual-content {
                flex-direction: column;
                align-items: flex-start;
                gap: 20px;

                h1 {
                    font-size: 36px;
                }

                .sitemap-wrap span {
                    font-size: 12px;
                }
            }

            i.ic {
                width: 16px;
                height: 16px;

                img {
                    width: 4px;
                }
            }
        }
    }
}
</style>
